import '../css/blocks.css';
import homePageContentBlock from "../../blocks/home-page-content/home-page-content";
import logosShowcaseBlock from "../../blocks/logos-showcase/logos-showcase";
import newsContentGalleryBlock from "../../blocks/news-content-gallery/news-content-gallery";
import newsListingBlock from "../../blocks/news-listing/news-listing";
import fundingOptionsBlock from "../../blocks/funding-options/funding-options";
import testimonialBlock from "../../blocks/testimonial/testimonial";
import youAlsoMightLikeBlock from "../../blocks/you-also-might-like/you-also-might-like";
import accordionBlock from "../../blocks/accordion/accordion";
import yourInvestmentBlock from "../../blocks/your-investment/your-investment";
import whatYouGetAsAMemberBlock from "../../blocks/what-you-get-as-a-member/what-you-get-as-a-member";
import onDemandLearningFeaturedBlock from "../../blocks/on-demand-learning-featured/on-demand-learning-featured";
import onDemandLearningListingBlock from "../../blocks/on-demand-learning-listing/on-demand-learning-listing";
import trainingAndEventsFeaturedBlock from "../../blocks/training-and-events-featured/training-and-events-featured";
import trainingAndEventsListingBlock from "../../blocks/training-and-events-listing/training-and-events-listing";
import videoEmbedBlock from "../../blocks/video-embed/video-embed";

document.addEventListener('DOMContentLoaded', function() {
  videoEmbedBlock();
  trainingAndEventsListingBlock();
  trainingAndEventsFeaturedBlock();
  onDemandLearningListingBlock();
  onDemandLearningFeaturedBlock();
  whatYouGetAsAMemberBlock();
  yourInvestmentBlock();
  accordionBlock();
  testimonialBlock();
  fundingOptionsBlock();
  newsContentGalleryBlock();
  newsListingBlock();
  logosShowcaseBlock();
  homePageContentBlock();
  youAlsoMightLikeBlock();
});
